export const VALUES_TABLE_ID = 'label-values-table';
export const VALUES_TABLE_PAGE_SIZE = 10;
export const DASHBOARD_COLUMN_TOOLTIP_ID = 'dashboard-visibility-tooltip';

export const VALUES_TABLE_COLUMN_WIDTHS = {
	VALUE: '270px',
	DASHBOARD_VISIBILITY: '200px',
	ACTIONS: '60px'
} as const;
